var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7364 0.654244C17.3849 0.302752 16.8151 0.302752 16.4636 0.654244L5.68104 11.4369L1.5364 7.29228C1.18494 6.94078 0.615131 6.94082 0.263604 7.29228C-0.0878882 7.64373 -0.0878882 8.21355 0.263604 8.56504L5.04464 13.346C5.39599 13.6975 5.96622 13.6972 6.31743 13.346L17.7364 1.92704C18.0879 1.57558 18.0878 1.00574 17.7364 0.654244Z",
    fill: "#10CAD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.6e3c347cb64fe5887b0684f1049a21ba.svg";
export { ForwardRef as ReactComponent };